import script from "./manage-products-in-bulk.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-products-in-bulk.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__